import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
        values: {
            home: 'mdi-home-account',

            my_page: 'mdi-home-account',
            my_account: 'mdi mdi-account-details',
            my_hourlist: 'mdi-account-clock',

            job: 'mdi-briefcase',
            job_list: 'mdi-clipboard-list',
            job_categories: 'mdi-bookmark-multiple',
            job_statuses: 'mdi-list-status',
            job_my: 'mdi-briefcase-account',
            job_partorder: 'mdi-fridge-alert',

            time: 'mdi-clock-time-eleven-outline',
            planner: 'mdi-calendar-text',
            appointment: 'mdi-calendar',

            contract: 'mdi-file-delimited',

            dashboard: 'mdi-desktop-mac-dashboard',

            admin: 'mdi-tune',
            delete: 'mdi-delete',
            documents: 'mdi-file-multiple',
            department: 'mdi-map-marker-radius',
            employment: 'mdi-account-sync',
            store: 'mdi-store',
            global_settings: 'mdi-cog-sync',
            save: 'mdi-content-save',
            accounts: 'mdi-account-group',
            administrator: 'mdi-shield-account',
            technician: 'mdi-badge-account',
            subcontractor: 'mdi-ticket-account',
            partner: 'mdi-account-group',
            customer_manager: 'mdi-account-tie',
            customer_employee: 'mdi-account',

            customer: 'mdi-domain',
            customer_list: 'mdi-clipboard-list',
            customer_group: 'mdi-home-group',
            customeraddress: 'mdi-office-building-marker',
            maps: 'mdi-google-maps',

            machine: 'miscellaneous_services',
            machine_list: 'mdi-clipboard-list',
            machine_categories: 'mdi-bookmark-multiple',
            machine_model: 'mdi-package-variant-closed',
            supplier: 'mdi-dolly',
            article: 'mdi mdi-pinwheel',
            counter: 'mdi-counter',
            supplier_failure_code: 'mdi-alpha-f-box',
            repair_code: 'mdi-alpha-r-box',
            warranty_type: 'mdi-artboard',
            repair_place: 'mdi-mailbox-up',
            partner_company: 'mdi-office-building',
            asset_type: 'mdi-home-percent',
            preventative_maintenance: 'mdi-file-clock',

            lead: 'mdi-brightness-percent',

            redirect: 'mdi-exit-run',
            about: 'mdi-book-information-variant',
        },
    },
    theme: {
        dark: false,
        options: {
            customProperties: true
        },
    }
});
